import { BlogListItem } from "./blog-list-item";
import { BlogListPagination } from "./blog-list-pagination";
import { BlogTags } from "./blog-tags";
import { useBlogList } from "./use-blog-list";

export const BlogList = () => {
  const { blogList, isLoading } = useBlogList();

  return (
    <div className="mx-auto flex w-full min-w-0 max-w-component-max-w-xl flex-col gap-8 px-4 py-8 md:px-6 lg:gap-10 lg:px-10 lg:py-12 xl:px-0">
      <BlogTags tags={blogList?.tags ?? []} />
      {isLoading ? (
        <div className="flex min-h-48 items-center justify-center">
          <div
            className="h-10 w-10 animate-spin rounded-full border-2 border-neutral-300 border-t-black"
            aria-label="Loading blog posts"
            role="status"
          />
        </div>
      ) : (
        <>
          <div className="grid gap-8 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
            {blogList?.stories.map((item) => (
              <BlogListItem key={item.slug} item={item} />
            ))}
          </div>
          <BlogListPagination
            currentPage={blogList?.currentPage ?? 1}
            totalPages={blogList?.totalPages ?? 1}
          />
        </>
      )}
    </div>
  );
};
